import { useNavigate } from "@tanstack/react-router";
import { useDebounce } from "ahooks";
import { useEffect, useRef, useState } from "react";

import { TextField } from "@/components/base/text-field";

type FilterNameProps = {
  value: string | null;
};

export function FilterName({ value }: FilterNameProps) {
  const navigate = useNavigate();
  const [local, setLocal] = useState(value ?? "");
  const userChanged = useRef(false);
  const debounced = useDebounce(local, { wait: 300 });

  useEffect(() => {
    if (
      userChanged.current &&
      debounced === local &&
      (debounced || null) !== value
    ) {
      navigate({
        replace: true,
        search: (prev) => ({
          ...prev,
          page: 1,
          name: debounced || null,
        }),
      });
    }
  }, [debounced, local, value, navigate]);

  // Sync local state when URL changes externally (e.g. clear filters)
  useEffect(() => {
    userChanged.current = false;
    setLocal(value ?? "");
  }, [value]);

  return (
    <TextField
      label="Name"
      placeholder="Search by name"
      value={local}
      onChange={(v) => {
        userChanged.current = true;
        setLocal(v);
      }}
    />
  );
}
